import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiKitModule } from '@serviceplan/ui-kit';
import { MatComponentsModule, StorageUtilityLib } from '@thehubz/client/core';
import { GuidedTourModule } from '@thehubz/client/guided-tour';
import { HeaderComponent, MainNavComponent } from './components';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';

@NgModule({
  imports: [CommonModule, MatComponentsModule, FormsModule, ReactiveFormsModule, UiKitModule, RouterModule, GuidedTourModule, TourMatMenuModule],
  declarations: [HeaderComponent, MainNavComponent],
  exports: [HeaderComponent],
  providers: [StorageUtilityLib],
})
export class ClientNavigationModule {}
